function e(e){return new Promise((t=>{setTimeout((()=>{t()}),e)}))}export{e as sleep};
